import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { DispatchBoard } from '@/features/dispatch/DispatchBoard'
import { requireNav } from '@/nav/guard'

export const Route = createFileRoute('/_app/dispatch')({
  beforeLoad: requireNav('dispatch'),
  validateSearch: z.object({
    week: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .optional()
      .catch(undefined),
  }),
  component: DispatchPage,
})

function DispatchPage() {
  const { week } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <DispatchBoard
      week={week}
      onWeekChange={(next) => void navigate({ search: { week: next }, replace: true })}
    />
  )
}
